(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jeordies-stores"] && !Shopify.designMode) return;
  try {
    
(() => {
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/đ/g, 'd').toLowerCase();
  const init = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const items = Array.from(root.querySelectorAll('[data-store-item]'));
    const city = root.querySelector('[data-store-city]');
    const search = root.querySelector('[data-store-search]');
    const panel = root.querySelector('.jd-stores__map-panel');
    const frame = root.querySelector('[data-store-map]');
    const placeholder = root.querySelector('[data-map-placeholder]');
    let selected;
    let mapLoaded = false;
    const supportsMap = (() => {
      try {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('webgl2') || canvas.getContext('webgl');
        if (!context) return false;
        const release = context.getExtension('WEBGL_lose_context');
        if (release) release.loseContext();
        return true;
      } catch (error) { return false; }
    })();
    const openMap = item => {
      if (!item) return;
      if (!supportsMap) {
        window.open(item.dataset.directions, '_blank', 'noopener,noreferrer');
        return;
      }
      mapLoaded = true;
      show(item);
      panel.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth',block:'nearest'});
    };
    const embed = item => {
      const lat = Number(item.dataset.lat);
      const lon = Number(item.dataset.lon);
      if (!Number.isFinite(lat) || !Number.isFinite(lon) || !item.dataset.lat || !item.dataset.lon) return '';
      const bbox = [lon - .012, lat - .008, lon + .012, lat + .008].join(',');
      return 'https://www.openstreetmap.org/export/embed.html?bbox=' + encodeURIComponent(bbox) + '&layer=mapnik&marker=' + encodeURIComponent(lat + ',' + lon);
    };
    const show = item => {
      selected = item;
      panel.hidden = !item;
      if (!item) { frame.removeAttribute('src'); return; }
      root.querySelector('[data-map-name]').textContent = item.dataset.name;
      root.querySelector('[data-map-city]').textContent = item.dataset.city;
      root.querySelector('[data-map-address]').textContent = item.dataset.address;
      root.querySelector('[data-map-directions]').href = item.dataset.directions;
      const url = embed(item);
      frame.hidden = !mapLoaded || !url;
      placeholder.hidden = mapLoaded && Boolean(url);
      root.querySelector('[data-load-map]').hidden = !url;
      if (mapLoaded && url) frame.src = url;
    };
    Array.from(new Set(items.map(item => item.dataset.city))).sort((a,b) => a.localeCompare(b,document.documentElement.lang)).forEach(value => {
      const option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      city.append(option);
    });
    const filter = () => {
      const term = normalize(search.value.trim());
      const visible = items.filter(item => {
        item.hidden = Boolean((city.value && item.dataset.city !== city.value) || !normalize(item.dataset.name + ' ' + item.dataset.city + ' ' + item.dataset.address).includes(term));
        return !item.hidden;
      });
      root.querySelector('[data-store-count]').textContent = visible.length;
      root.querySelector('[data-store-empty]').hidden = visible.length > 0;
      items.forEach(item => { item.open = false; });
      if (visible[0]) visible[0].open = true;
      show(visible[0]);
    };
    items.forEach(item => {
      item.addEventListener('toggle', () => {
        if (!item.open || item.hidden) return;
        items.forEach(other => { if (other !== item) other.open = false; });
        show(item);
      });
      item.querySelector('[data-show-store]').addEventListener('click', () => {
        openMap(item);
      });
    });
    root.querySelector('[data-load-map]').addEventListener('click', () => openMap(selected));
    city.addEventListener('change',filter);
    search.addEventListener('input',filter);
    show(items[0]);
  };
  document.querySelectorAll('[data-jd-stores]').forEach(init);
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-jd-stores]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();
})();
